export default {
  getStarCategoryList: {
    title: '获取内容分类列表',
    method: 'post',
    url: '/api/as/service/star/category/list',
    headers: {
      'Content-Type': 'application/json',
      cid: 12
    }
  },
  getSubStarCategoryList: {
    title: '获取二级分类列表',
    url: '/api/as/service/star/category/second/list',
    headers: {
      cid: 12
    }
  },
  getStarContentList: {
    title: '获取内容列表',
    method: 'post',
    url: '/api/as/service/star/contents/list',
    headers: {
      'Content-Type': 'application/json',
      cid: 12
    }
  },
  getStarContentDetail: {
    title: '获取内容详情',
    url: '/api/as/service/star/contents/detail',
    headers: {
      cid: 12
    }
  }
}
